/**
 * Swiper слайдери - окремий модуль для оптимізації завантаження
 * Переписано на ванільний JavaScript
 */

import Swiper from 'swiper/bundle';

// Глобальне присвоєння Swiper
window.Swiper = Swiper;

const initSliders = () => {
    console.log('🎯 Initializing Sliders...');
    
    const domReady = (callback) => {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    };

    domReady(() => {
        // Локалізація повідомлень
        let prevSlideMessage = 'Previous slide';
        let nextSlideMessage = 'Next slide';
        let firstSlideMessage = 'This is the first slide';
        let lastSlideMessage = 'This is the last slide';

        const htmlLang = document.documentElement.getAttribute('lang');
        
        if (htmlLang === 'lt-LT') {
            prevSlideMessage = 'Ankstesnė skaidrė';
            nextSlideMessage = 'Sekanti skaidrė';
            firstSlideMessage = 'Tai yra pirmoji skaidrė';
            lastSlideMessage = 'Tai yra paskutinė skaidrė';
        } else if (htmlLang === 'en-US') {
            prevSlideMessage = 'Previous slide';
            nextSlideMessage = 'Next slide';
            firstSlideMessage = 'This is the first slide';
            lastSlideMessage = 'This is the last slide';
        } else if (htmlLang === 'ru-RU') {
            prevSlideMessage = 'Предыдущий слайд';
            nextSlideMessage = 'Следующий слайд';
            firstSlideMessage = 'Это первый слайд';
            lastSlideMessage = 'Это последний слайд';
        }

        const handleDuplicateSlides = () => {
            const duplicateSlides = document.querySelectorAll('.swiper-slide-duplicate');
            duplicateSlides.forEach(slide => {
                slide.setAttribute('aria-hidden', 'true');
                slide.setAttribute('tabindex', '0');
            });
        };

        // Company Benefit Swiper
        const companyBenefitSwiperElement = document.querySelector('.company-benefit-swiper');
        if (companyBenefitSwiperElement) {
            const companyBenefitSwiper = new Swiper('.company-benefit-swiper', {
                // Основні параметри
                direction: 'horizontal',
                slideShadows: false,
                loop: true,
                slidesPerView: 1,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                loopPreventsSlide: false,
                centeredSlides: true,
                navigation: {
                    nextEl: '.slider-next-btn',
                    prevEl: '.slider-prev-btn',
                },
                speed: 1000,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 10,
                    loadOnTransitionStart: true
                },
                a11y: true,
                prevSlideMessage: prevSlideMessage,
                nextSlideMessage: nextSlideMessage,
                firstSlideMessage: firstSlideMessage,
                lastSlideMessage: lastSlideMessage,
                // Responsive breakpoints
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 17,
                        autoplay: false,
                        speed: 600,
                        centeredSlides: false,
                    },
                    400: {
                        slidesPerView: 1.5,
                        spaceBetween: 32
                    },
                    800: {
                        slidesPerView: 2.5,
                        spaceBetween: 64
                    },
                    1100: {
                        slidesPerView: 3.5,
                        spaceBetween: 64
                    },
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: 64
                    },
                    1800: {
                        slidesPerView: 4.25,
                        spaceBetween: 64
                    },
                    2400: {
                        slidesPerView: 5.25,
                        spaceBetween: 64
                    },
                },
                // Колбеки
                on: {
                    init: function () {
                        handleDuplicateSlides();
                    },
                    slideChange: function () {
                        handleDuplicateSlides();
                    }
                },
            });
        }

        // Benefit Swiper  
        const benefitSwiperElement = document.querySelector('.benefit-swiper');
        if (benefitSwiperElement) {
            const benefitSwiper = new Swiper('.benefit-swiper', {
                // Основні параметри
                direction: 'horizontal',
                slideShadows: false,
                loop: true,
                slidesPerView: 1,
                centeredSlides: false,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                loopPreventsSlide: false,
                speed: 1200,
                spaceBetween: 0
            });
        }

        const plansSliderElement = document.querySelector('.service-plans__slider');
        let plansSwiper = null;

        if (plansSliderElement) {
            const syncPlansSlider = () => {
                const shouldEnableSlider = window.innerWidth <= 767;

                if (shouldEnableSlider && !plansSwiper) {
                    plansSwiper = new Swiper(plansSliderElement, {
                        slidesPerView: 1,
                        spaceBetween: 16,
                        speed: 500,
                        navigation: {
                            nextEl: '.service-plans__nav--next',
                            prevEl: '.service-plans__nav--prev',
                        },
                    });
                }

                if (!shouldEnableSlider && plansSwiper) {
                    plansSwiper.destroy(true, true);
                    plansSwiper = null;
                }
            };

            syncPlansSlider();
            window.addEventListener('resize', syncPlansSlider);
        }

        const PhotoGallerySwiperElement = document.querySelector('.photo-gallery--swiper');
        if (PhotoGallerySwiperElement) {
            const PhotoGallerySwiperElement = new Swiper('.photo-gallery--swiper', {
                // Основні параметри
                direction: 'horizontal',
                slideShadows: false,
                loop: true,
                slidesPerView: 1,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                loopPreventsSlide: false,
                centeredSlides: true,
                navigation: {
                    nextEl: '.slider-next-btn',
                    prevEl: '.slider-prev-btn',
                },
                speed: 1000,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 10,
                    loadOnTransitionStart: true
                },
                a11y: true,
                prevSlideMessage: prevSlideMessage,
                nextSlideMessage: nextSlideMessage,
                firstSlideMessage: firstSlideMessage,
                lastSlideMessage: lastSlideMessage,
                pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar"
                },
                // Responsive breakpoints
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 17,
                        autoplay: false,
                        speed: 600,
                        centeredSlides: false,
                    },
                    400: {
                        slidesPerView: 1.5,
                        spaceBetween: 24
                    },
                    800: {
                        slidesPerView: 2.5,
                        spaceBetween: 24
                    },
                    1100: {
                        slidesPerView: 3.5,
                        spaceBetween: 24
                    },
                    1400: {
                        slidesPerView: 3.75,
                        spaceBetween: 24
                    },
                    1800: {
                        slidesPerView: 4.25,
                        spaceBetween: 24
                    },
                    2400: {
                        slidesPerView: 5.25,
                        spaceBetween: 24
                    },
                },
                on: {
                    init: function () {
                        handleDuplicateSlides();
                    },
                    slideChange: function () {
                        handleDuplicateSlides();
                    }
                },
            });
        }
    });
};

// Експортуємо функцію для можливості викликати з інших модулів
window.initSliders = initSliders;

// Автоматична ініціалізація
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
} else {
    initSliders();
}

export { initSliders };